export const authAreas = [

    {
        id: 1,
        legajo: 28367,
        areas: ['Dirección_de_Informática', 'ECONET', 'Dirección_de_Publicaciones', 'Dirección_de_Alumnos', 'Departamento_Clases_y_Exámenes', 'Docentes']
    },
    {
        id: 2,
        legajo: 33914,
        areas: ['Dirección_de_Informática', 'ECONET', 'Dirección_de_Publicaciones']
    },

    {
        id: 4,
        legajo: 31768,
        areas: ['Decanato', 'Secretaría_de_Administración_y_Finanzas', 'Dirección_de_RRHH', 'Dirección_de_Servicios_Generales', 'Dirección_General_de_Gestión_Administrativo_Financiera', 'Dirección_de_Despacho', 'Departamento_Mesa_de_Entradas']
    },
    {
        id: 5,
        legajo: 24991,
        areas: ['Dirección_General_de_Gestión_Académica', 'Dirección_de_Alumnos', 'Departamento_Clases_y_Exámenes', 'Dirección_de_Biblioteca', 'Carrera_Licenciatura_en_Administración', 'Carrera_Contador_Público', 'Carrera_Licenciatura_en_Economía']
    },
    {
        id: 6,
        legajo: 28982,
        areas: ['Dirección_General_de_Gestión_Académica', 'Dirección_de_Alumnos', 'Carrera_Licenciatura_en_Administración', 'Carrera_Contador_Público', 'Carrera_Licenciatura_en_Economía', 'Departamento_Clases_y_Exámenes', 'Dirección_de_Biblioteca']

    },
    {
        id: 7,
        legajo: 22720,
        areas: ['Dirección_de_Despacho', 'Departamento_Mesa_de_Entradas']

    },
    {
        id: 8,
        legajo: 22028,
        areas: ['Dirección_de_Alumnos', 'Departamento_Clases_y_Exámenes']

    }
]
